export const UPDATED = 'simplecasino/receipts/UPDATED'
export const TOTALS_UPDATED = 'simplecasino/receipts/TOTALS_UPDATED'
export const TOTAL_DEPOSITS_UPDATED =
  'simplecasino/receipts/TOTAL_DEPOSITS_UPDATED'
